import { render, staticRenderFns } from "./AdministrationOrders.vue?vue&type=template&id=79707a18&scoped=true&"
import script from "./AdministrationOrders.vue?vue&type=script&lang=js&"
export * from "./AdministrationOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79707a18",
  null
  
)

export default component.exports